module.exports = __webpack_public_path__ + "img/3Dian5_9.323c748e.png";